export default "__VITE_ASSET__AzAyJdO4__"